"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.InputContext = exports.InputConsumer = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _useMountedState = _interopRequireDefault(require("react-use/lib/useMountedState"));
var _classnames = _interopRequireDefault(require("classnames"));
var _useDebouncedCallback3 = _interopRequireDefault(require("use-debounce/lib/useDebouncedCallback"));
var _styles = require("@material-ui/styles");
var _WebformView = require("../../View/WebformView/WebformView");
var _debounce = require("../../const/debounce");
var _getErrorMessage = _interopRequireDefault(require("../../utils/getErrorMessage"));
var _getFieldValue = _interopRequireDefault(require("../../utils/getFieldValue"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import { type JSONSchema } from '@catalytic/json-schema-validator-catalytic-web';*/
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var inputMarginTop = {
    '& + $input': {
      marginTop: theme.functions.toRem(theme.variables.inputMarginTop)
    }
  };
  return {
    root: _objectSpread(_objectSpread({}, theme.mixins.breakWord), {}, {
      marginBottom: theme.functions.toRem(theme.variables.inputMarginBottom),
      backgroundColor: theme.colors.white,
      textAlign: 'left'
    }),
    errorMarginBottom: {
      marginBottom: 0
    },
    title: _objectSpread(_objectSpread(_objectSpread({}, theme.typography.baseText), inputMarginTop), {}, {
      display: 'block',
      color: theme.colors.black,
      fontWeight: 700
    }),
    description: _objectSpread(_objectSpread({}, theme.typography.smallText), inputMarginTop),
    example: _objectSpread(_objectSpread(_objectSpread({}, theme.typography.smallText), inputMarginTop), {}, {
      color: theme.colors.slateGrey
    }),
    error: _objectSpread(_objectSpread({}, theme.mixins.inputErrorMessage), inputMarginTop),
    input: theme.mixins.inputMargin
  };
});
/*:: type Context = {
  'aria-describedby'?: string,
  'aria-invalid'?: boolean,
  'aria-labelledby'?: string,
  className: string,
  disabled: boolean,
  displayErrors: boolean,
  hasError: boolean,
  inputClassName?: string,
  onBlur?: (...args: Array<any>) => any,
  onChange?: (...args: Array<any>) => any,
  readOnly: boolean,
  setDisplayErrorsState: (...args: Array<any>) => any,
  setLoadingState: (...args: Array<any>) => any
};*/
var InputContext /*: React.Context<Context | void>*/ = exports.InputContext = React.createContext();
/*:: type Props = {
  children: React.Node,
  className?: string,
  contextValues?: { [string]: any },
  description?: null | string | React.Element<typeof FormattedMessage>,
  descriptionClassName?: string,
  disabled?: boolean,
  displayErrors?: boolean,
  error?: string | React.Element<typeof FormattedMessage> | Error,
  errorClassName?: string,
  errorMessage?: string,
  example?: null | string | React.Element<typeof FormattedMessage>,
  exampleClassName?: string,
  fieldName?: string,
  hasError?: boolean,
  hasValidation?: boolean,
  id: string,
  inputClassName?: string,
  inputElementClassName?: string,
  name: string,
  onBlur?: (...args: Array<any>) => any,
  onChange?: (...args: Array<any>) => any,
  readOnly?: boolean,
  schema?: JSONSchema<>,
  title?: string | React.Element<typeof FormattedMessage>,
  titleClassName?: string,
  type?: string,
  value?: any
};*/
var getInputErrorMessage = function getInputErrorMessage(_ref) {
  var contextValues = _ref.contextValues,
    errorMessage = _ref.errorMessage,
    name = _ref.name,
    schema = _ref.schema,
    value = _ref.value;
  var inputErrorMessage = (0, _getErrorMessage.default)({
    contextValues: contextValues,
    name: name,
    schema: schema,
    value: value
  }) || errorMessage;
  return inputErrorMessage;
};
var Input = function Input(_ref2 /*:: */) {
  var children = _ref2 /*:: */.children,
    className = _ref2 /*:: */.className,
    contextValues = _ref2 /*:: */.contextValues,
    description = _ref2 /*:: */.description,
    descriptionClassName = _ref2 /*:: */.descriptionClassName,
    disabledProp = _ref2 /*:: */.disabled,
    displayErrorsInputProp = _ref2 /*:: */.displayErrors,
    errorProp = _ref2 /*:: */.error,
    errorClassName = _ref2 /*:: */.errorClassName,
    errorMessageProp = _ref2 /*:: */.errorMessage,
    example = _ref2 /*:: */.example,
    exampleClassName = _ref2 /*:: */.exampleClassName,
    fieldName = _ref2 /*:: */.fieldName,
    hasErrorProp = _ref2 /*:: */.hasError,
    hasValidation = _ref2 /*:: */.hasValidation,
    id = _ref2 /*:: */.id,
    inputClassName = _ref2 /*:: */.inputClassName,
    inputElementClassName = _ref2 /*:: */.inputElementClassName,
    name = _ref2 /*:: */.name,
    onBlur = _ref2 /*:: */.onBlur,
    onChange = _ref2 /*:: */.onChange,
    readOnlyProp = _ref2 /*:: */.readOnly,
    schema = _ref2 /*:: */.schema,
    title = _ref2 /*:: */.title,
    titleClassName = _ref2 /*:: */.titleClassName,
    type = _ref2 /*:: */.type,
    value = _ref2 /*:: */.value;
  var classes = useStyles();
  var getMountedState = (0, _useMountedState.default)();
  var isMounted = getMountedState();
  var _React$useState = React.useState(getInputErrorMessage({
      contextValues: contextValues,
      errorMessage: errorMessageProp,
      name: fieldName || name,
      schema: schema,
      value: value
    })),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    errorMessage = _React$useState2[0],
    setErrorMessage = _React$useState2[1];
  var _useDebouncedCallback = (0, _useDebouncedCallback3.default)(function (value) {
      return setErrorMessage(value);
    }, _debounce.WAIT),
    _useDebouncedCallback2 = (0, _slicedToArray2.default)(_useDebouncedCallback, 1),
    debouncedSetErrorMessage = _useDebouncedCallback2[0];
  var handleBlur = React.useCallback(function () {
    var _event$currentTarget;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var event = args[0];
    var value = event === null || event === void 0 ? void 0 : (_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.value;
    var fieldValue = (0, _getFieldValue.default)(value, type);

    // Update input error message when input has blurred.
    if (isMounted) {
      setErrorMessage(getInputErrorMessage({
        contextValues: contextValues,
        errorMessage: errorMessageProp,
        name: fieldName || name,
        schema: schema,
        value: fieldValue
      }));
    }
    if (typeof onBlur === 'function') {
      onBlur.apply(void 0, args);
    }
  }, [contextValues, errorMessageProp, fieldName, isMounted, name, onBlur, schema, type]);
  var handleChange = React.useCallback(function () {
    var _event$currentTarget2;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    var event = args[0];
    var value = event === null || event === void 0 ? void 0 : (_event$currentTarget2 = event.currentTarget) === null || _event$currentTarget2 === void 0 ? void 0 : _event$currentTarget2.value;
    var fieldValue = (0, _getFieldValue.default)(value, type);

    // Update input error message when input has changed.
    if (isMounted) {
      debouncedSetErrorMessage(getInputErrorMessage({
        contextValues: contextValues,
        errorMessage: errorMessageProp,
        name: fieldName || name,
        schema: schema,
        value: fieldValue
      }));
    }
    if (typeof onChange === 'function') {
      onChange.apply(void 0, args);
    }
  }, [contextValues, debouncedSetErrorMessage, errorMessageProp, fieldName, isMounted, name, onChange, schema, type]);

  // Update input error message when props have changed.
  React.useEffect(function () {
    setErrorMessage(getInputErrorMessage({
      contextValues: contextValues,
      errorMessage: errorMessageProp,
      name: fieldName || name,
      schema: schema,
      value: value
    }));
  }, [contextValues, errorMessageProp, fieldName, name, schema, value]);
  return /*#__PURE__*/React.createElement(_WebformView.WebformViewConsumer, null, function (props) {
    var _ref3 = props || {},
      disabled = _ref3.disabled,
      displayErrorsWebformProp = _ref3.displayErrors,
      readOnly = _ref3.readOnly,
      setDisplayErrorsState = _ref3.setDisplayErrorsState,
      setLoadingState = _ref3.setLoadingState;
    var displayErrors = displayErrorsWebformProp || displayErrorsInputProp || false; // Show errors if either the input or the overall webform sets displayErrors
    var shouldDisplayErrorMessage = displayErrors && hasValidation;
    var visibleErrorMessage = shouldDisplayErrorMessage ? errorMessage : undefined;
    var visibleError = errorProp instanceof Error ? errorProp.message : errorProp;
    var error = visibleError || visibleErrorMessage;
    var hasError = Boolean(error);
    var isDisabled = disabledProp || disabled;
    var isReadOnly = readOnlyProp || readOnly;
    var ariaDescribedby = description ? "".concat(id, "-description") : undefined;
    var ariaInvalid = hasError ? true : undefined;
    var ariaLabelledby = title ? "".concat(id, "-label") : undefined;
    return /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.errorMarginBottom, error), className),
      "data-id": name // Required for scroll invalid input into view logic tied to `WebformView` component
      ,
      "data-error": hasValidation ? errorMessage : undefined // Required for scroll invalid input into view logic tied to `WebformView` component
    }, title && /*#__PURE__*/React.createElement("label", {
      className: (0, _classnames.default)(classes.title, titleClassName),
      htmlFor: !isDisabled && !isReadOnly ? id : undefined,
      id: "".concat(id, "-label")
    }, title), description && /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames.default)(classes.description, descriptionClassName),
      id: "".concat(id, "-description")
    }, description), example && /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames.default)(classes.example, exampleClassName)
    }, example), /*#__PURE__*/React.createElement(InputContext.Provider, {
      value: {
        'aria-describedby': ariaDescribedby,
        'aria-invalid': ariaInvalid,
        'aria-labelledby': ariaLabelledby,
        className: (0, _classnames.default)(classes.input, inputClassName),
        disabled: isDisabled,
        displayErrors: displayErrors,
        hasError: hasErrorProp || hasError,
        inputClassName: inputElementClassName,
        onBlur: handleBlur,
        onChange: handleChange,
        readOnly: isReadOnly,
        setDisplayErrorsState: setDisplayErrorsState,
        setLoadingState: setLoadingState
      }
    }, children), hasError && /*#__PURE__*/React.createElement("div", {
      className: (0, _classnames.default)(classes.error, errorClassName)
    }, error));
  });
};
Input.displayName = 'Input';
var _default = exports.default = React.memo(Input);
var InputConsumer = exports.InputConsumer = InputContext.Consumer;
//# sourceMappingURL=InputV2.js.map